import { useAtom } from 'ximple';
import { voucherAtom } from 'src/state/voucher/voucherAtom';
import SummaryPromoCode from '../summary/SummaryPromoCode';
import { useConfigurations } from '@repo/widget-utils/widgetsConfiguration';
import { Box } from '@mui/material';

type SummaryPromoCodeProps = {
    writable?: boolean;
    giftcardValue: number;
};

/**
 * Wrapper for SummaryPromoCode that only displays the promo code if the feature flag is enabled.
 * @param props
 * @returns
 */
export function GiftCardPromoCode(props: SummaryPromoCodeProps) {
    const config = useConfigurations();
    const [{ appliedPromoCode }] = useAtom(voucherAtom);
    const currentPriceReduction =
        appliedPromoCode?.coupon_type === 'percent'
            ? props.giftcardValue * (appliedPromoCode?.coupon_value / 100)
            : (appliedPromoCode?.coupon_value ?? 0);

    const promoSupportsGiftcard = appliedPromoCode?.for_giftcard;

    if (config.enableGiftcardPromoCodes) {
        return (
            <Box pt={1}>
                <SummaryPromoCode
                    currentPriceReduction={promoSupportsGiftcard ? currentPriceReduction : 0}
                    writeable={props.writable}
                />
            </Box>
        );
    }
    return null;
}
